<template>
  <div id="lorder">
    <div class="lorderFirst">
      <div
        class="lorderTitle"
        v-for="(item, index) in title"
        :key="index"
        :class="[{ active: activeName == item.name }]"
      >
        <div class="lorderTitleName">{{ item.name }}</div>
        <div :class="[{ lorderTitleBorder: activeName == item.name }]"></div>
      </div>
    </div>
    <div>
      <div id="lMyMTraining">
        <div class="lMyMTrainingFirst">
          <div class="lMyMTrainingFirstSelect">
            <span>状态</span>
            <Select class="zhuangtya" v-model="yearNum" @on-change="yearChange">
              <Option
                v-for="item in periodList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}
              </Option>
            </Select>
          </div>
        </div>
        <div
          style="
            color: red;
            font-size: 15px;
            margin-bottom: 20px;
            display: flex;
            justify-content: center;
            
          "
        >
          关闭状态的订单将于7天后清理
        </div>
        <div v-if="num == 1">
          <Table :columns="columns1" :data="data1" max-height="892">
            <!-- <template slot-scope="{ row, index }" slot="signUp">
							<div class="xueshixiugai" v-if="row.status == 5" @click="modify(row,index)">修改学时</div>
						</template> -->

            <template slot-scope="{ row, index }" slot="action">
              <div class="caozuodingdan">
                
                <span
                  v-if="row.status != 2 && row.status != 3"
                  @click="xiangqing(row, index)"
                  style="margin-right: 10px"
                  >详情</span
                >
                
                <el-dropdown v-if="row.status != 2">
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="express(row, index)">
                      <div v-if="row.status == 5"  style="width:100%" >快递查询</div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="delOrder(row, index)">
                      <div v-if="row.status == 1"  style="width:100%">取消订单</div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="jiaofei(row, index)">
                      <div style="width:100%" v-if="row.status == 1">缴费</div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="returnMoney(row, index)">
                      <div
                        style="width:100%"
                        v-if="row.status == 5 && row.type !== 2 && row.runDate <= 365 && row.projectType == 1"
                        >申请退款</div
                      >
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="returnSuggestion(row, index)">
                      <div
                        style="width:100%"
                        v-if="row.status == 5 && row.type !== 2 && row.projectType == 1"
                        >驳回理由</div
                      >
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="IncreasePeriod(row, index)" v-if="row.editCreditEnable == 2">
                      <div
                        style="width:100%"
                        v-if="row.status == 5 && row.type !== 2"
                        >申请增加学时</div
                      >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </Table>
        </div>

        <div v-if="num == 2">
          <Table :columns="columns2" :data="data1" max-height="892">
            <template slot-scope="{ row, index }" slot="action">
              <div class="caozuodingdan">
                
                <span
                  v-if="row.status != 2 && row.status != 3"
                  @click="xiangqing(row, index)"
                  style="margin-right: 10px"
                  >详情</span
                >
                
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="express(row, index)">
                      <span v-if="row.status == 5"
                      style="margin-right: 10px"
                      >快递查询</span>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="delOrder(row, index)">
                      <span v-if="row.status == 1" >取消订单</span>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="jiaofei(row, index)">
                      <span class="daingdanxia"  v-if="row.status == 1"  >缴费</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <span v-if="row.status==5" class="daingdanxia" @click="returnMoney(row, index)">申请退款</span> -->
              </div>
            </template>
          </Table>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <Page
          :total="total"
          show-total
          :current="curPage"
          :page-size="maxPage"
          @on-change="onChange"
        />
      </div>
      <Modal :mask-closable="false" v-model="modal1" title="缴费">
        <div style="text-align: center">
          <span class="paymentSpan">请使用微信或支付宝扫码支付</span>
          <img :src="src" alt="" />
        </div>
        <div slot="footer" style="display: flex; justify-content: center">
          <Button type="primary" size="large" @click="confirm">确认支付</Button>
        </div>
      </Modal>
      <Modal :mask-closable="false" v-model="ModifyFlag" title="增加学时申请">
        <Form ref="formInlines" :model="formInlines" :label-width="120">
          <FormItem label="增加学时至:">
            <Select v-model="increase.selectCredit" @on-change="selectCredit">
              <Option
                v-for="item in priceList"
                :value="item.name"
                :key="item.name"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="需再支付:">
            <el-input
              v-model="increase.money"
              type="textarea"
              disabled
              placeholder="请选择需要增加学时"
            />
          </FormItem>
          <FormItem label=" 增加学时理由:">
            <el-input v-model="increase.addReason" placeholder="请输入理由" />
          </FormItem>
        </Form>
        <div slot="footer" style="display: flex; justify-content: center">
          <Button
            type="primary"
            size="large"
            class="footer-btn"
            @click="abolish"
            >取消</Button
          >
          <Button
            type="primary"
            size="large"
            class="footer-btn"
            @click="notarize"
            >确认</Button
          >
        </div>
      </Modal>
      <Modal :mask-closable="false" v-model="modal" title="退款申请">
        <div>
          <Form ref="formInline" :model="formInline" :rules="ruleInline">
            <FormItem label="开户银行" prop="bankBranchName">
              <Input
                v-model="formInline.bankBranchName"
                placeholder="请输入开户银行名称，并准确填写到支行"
              />
            </FormItem>
            <FormItem label="退款账号" prop="bankAccount">
              <Input
                v-model="formInline.bankAccount"
                placeholder="请输入退款账号"
              />
            </FormItem>
            <FormItem label="退款理由" prop="refundReson">
              <Input
                v-model="formInline.refundReson"
                :autosize="true"
                type="textarea"
                placeholder="请输入理由"
              />
            </FormItem>
            <FormItem label="快递单号">
              <Input
                v-model="formInline.traceNumber"
                placeholder="如已领取教材请将教材寄回并填写快递单号"
              />
            </FormItem>
          </Form>
          <div v-if="num == 2">
            <Table
              ref="table"
              @on-selection-change="selectionChange"
              :columns="columns"
              :data="list"
              class="ivu-mt"
            >
            </Table>
          </div>
        </div>
        <div slot="footer">
          <Button @click="cancel">取消</Button>
          <Button @click="submit">提交</Button>
        </div>
      </Modal>

      <Modal :mask-closable="false" v-model="modalSuggestion" title="驳回理由">
        <div>
          <Form ref="formInlines">
            <FormItem label="退款驳回理由">
              <Input
                v-model="rowData.suggestion"
                readonly
                type="textarea"
                placeholder="退款驳回理由"
              />
            </FormItem>
          </Form>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  queryUserOrder,
  queryOrderDetail,
  cancelOrder,
} from "../../../network/LPersonal";
import {
  genQRCode,
  payCallBack,
  queryExpressNumber,
  refundApply,
  selectRefundPeople,
} from "../../../network/home";
import {findProject, editCreditOrder} from '../../../network/study'
export default {
  name: "news",
  data() {
    const validatorAccount = (rule, value, callback) => {
      if (this.formInline.bankBranchName) {
        if (/[0-9]+$/.test(this.formInline.bankBranchName)) {
          // let texts = this.formInline.bankAccount.replace(/[0-9]+$/,'')
          // console.log(texts)
          // this.$set(this.formInline,'bankAccount',texts)
          // this.$forceUpdate()
          callback(
            new Error("请输入开户银行名称，并准确填写到支行,且不包含数字")
          );
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入开户银行名称，并准确填写到支行"));
      }
    };
    let newDate = new Date;
    let year = newDate.getFullYear();
    return {
      num: 1,
      formInline: {},
      formInlines: {},
      yearNum: "全部",
      increase: {},
      periodList: [],
      year,
      ruleInline: {
        bankAccount: [
          {
            required: true,
            trigger: "blur",
            message: "请输入退款账号",
          },
        ],
        bankBranchName: [
          {
            required: true,
            trigger: "blur",
            validator: validatorAccount,
          },
        ],
        refundReson: [
          {
            required: true,
            message: "请输入理由",
            trigger: "blur",
          },
        ],
      },
      cityList: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "支付成功",
          label: "支付成功",
        },
        {
          value: "待支付",
          label: "待支付",
        },
        {
          value: "已退订",
          label: "已退订",
        },
        {
          value: "订单关闭",
          label: "订单关闭",
        },
        {
          value: "待审核退款",
          label: "待审核退款",
        },
      ],
      columns: [
        {
          title: "选择框",
          align: "center",
          key: "checkBox",
          type: "selection",
          width: 40,
        },
        {
          title: "姓名",
          key: "fullName",
          align: "center",
        },
        {
          title: "身份证号",
          key: "idCard",
          align: "center",
        },
      ],
      list: [],
      columns1: [
        {
          title: "订单号",
          key: "orderNo",
          align: "center",
          minWidth: 100,
        },
        {
          title: "项目名称",
          key: "projectName",
          align: "center",
          minWidth: 70,
        },
        {
          title: "报名时间",
          key: "orderTime",
          sortable: true,
          minWidth: 50,
        },
        // {
        // 	title: "修改学时",
        // 	key: "age",
        // 	slot: "signUp",
        // 	minWidth: 50
        // },
        {
          title: "状态",
          key: "learnStatus",
          slot: "learnStatus",
          minWidth: 50,
          render(h, params) {
            if (params.row.status == 1) {
              return h(
                "span",
                {
                  style: {
                    color: "red",
                  },
                },
                "待支付"
              );
            } else if (params.row.status == 3) {
              return h(
                "span",
                {
                  style: {
                    color: "#3562E8",
                  },
                },
                "订单关闭"
              );
            } else if (params.row.status == 4) {
              return h(
                "span",
                {
                  style: {
                    color: "#3DA001",
                  },
                },
                "待审核退款"
              );
            } else if (params.row.status == 5) {
              return h(
                "span",
                {
                  style: {
                    color: "#808080",
                  },
                },
                "支付成功"
              );
            } else if (params.row.status == 2) {
              return h(
                "span",
                {
                  style: {
                    color: "#00aaaa",
                  },
                },
                "已退订"
              );
            }
          },
        },
        {
          title: "操作",
          key: "loading",
          slot: "action",
          align: "center",
          minWidth: 120,
        },
      ],
      columns2: [
        {
          title: "订单号",
          key: "orderNo",
        },
        {
          title: "企业名称",
          key: "fullName",
        },
        {
          title: "报名人数",
          key: "userList.lenght",
        },
        {
          title: "状态",
          key: "learnStatus",
          slot: "learnStatus",
          render(h, params) {
            if (params.row.status == 1) {
              return h(
                "span",
                {
                  style: {
                    color: "red",
                  },
                },
                "待支付"
              );
            } else if (params.row.status == 3) {
              return h(
                "span",
                {
                  style: {
                    color: "#3562E8",
                  },
                },
                "订单关闭"
              );
            } else if (params.row.status == 4) {
              return h(
                "span",
                {
                  style: {
                    color: "#3DA001",
                  },
                },
                "待审核退款"
              );
            } else if (params.row.status == 5) {
              return h(
                "span",
                {
                  style: {
                    color: "#808080",
                  },
                },
                "支付成功"
              );
            } else if (params.row.status == 2) {
              return h(
                "span",
                {
                  style: {
                    color: "#00aaaa",
                  },
                },
                "已退订"
              );
            }
          },
        },
        {
          title: "退补",
          key: "age",
        },
        {
          title: "快递单号",
          key: "age",
        },
        {
          title: "操作",
          key: "loading",
          slot: "action",
          align: "center",
          minWidth: 120,
        },
      ],
      data1: [],
      selectList: [],
      total: 0,
      title: [
        {
          name: "个人订单管理",
          key: 0,
        },
        {
          name: "企业订单管理",
          key: 1,
        },
      ],
      activeName: "个人订单管理",
      formItem: {
        input: "",
      },
      uid: "",
      type: 0,
      curPage: 1,
      maxPage: 10,
      orderNo: "",
      src: "",
      modal1: false,
      ModifyFlag: false,
      modal: false,
      baseData: {},
      rowData: {},
      modalSuggestion: false,
      priceList: [],
      credit: {},
    };
  },

  created() {
    // this.codeSplice("123456789");
    this.uid = this.Get("userId");
    if (this.Get("type") == 1) {
      this.num = 2;
      this.activeName = "企业订单管理";
      this.title = [
        {
          name: "企业订单管理",
          key: 1,
        },
      ];
    } else if (this.Get("type") == 0) {
      this.num = 1;
      this.activeName = "个人订单管理";
      this.title = [
        {
          name: "个人订单管理",
          key: 1,
        },
      ];
    }
    console.log(this.num);
    this.getData();
  },
  watch: {
    modal1() {
      if (!this.modal1) {
        clearInterval(this.time);
        this.getData();
      }
    },
    modal() {
      if (!this.modal) {
        this.formInline = {};
        this.list = [];
        this.selectList = [];
      }
    },
  },
  methods: {
    selectCredit(credit) {
      let obj = this.priceList.find(n => n.name === credit);
      let e = obj.price;
      if(e === this.credit.baseCredit) {
        return this.$message.info('请选择当前年份不一样的学时')
      }
      this.$set(this.increase,'money',(e - this.credit.baseMoney).toFixed(2));
      if(this.increase.momey < 0) {
        this.$set(this.increase,'money',0)
      }
    },
    IncreasePeriod(row) {
      this.increase.oldOrderNo = row.orderNo;
      findProject(row.orderNo).then(res => {
        this.credit = res.data.data;
        let o = this.credit.projectCredit.replace("{", "");
          o = o.replace("}", "");
          o = o.split(",");
          if (o.length > 0) {
              let arr1 = [];
              let arr2 = [];
              o.forEach((e) => {
                  let obj = {};
                  if (e) {
                      let i = e.indexOf(":");
                      let str = e.substring(i, 0);
                      let idx = e.indexOf('-');
                      let str1 = e.substring(i + 1, 10);
                      if(idx >= 0) {
                          str1 = e.substring(i+1,idx);
                          let str2 = e.substring(idx+1,e.length);
                          obj.vipPrice = str2;
                      }
                      obj.name = str.trim();
                      obj.price = Number(str1);
                      arr1.push(obj);
                      arr2.push(str);
                      if(obj.name == this.credit.baseCredit) {
                        this.credit.baseMoney = str1;
                      }
                  }
              });
              console.log(arr2);
              this.priceList = arr1;
              
              console.log(this.priceList,'IncreasePeriodIncreasePeriod');
              let pIndex = this.priceList.findIndex(x => x.name == this.credit.baseCredit);
              if(pIndex < 0) {
                this.ModifyFlag = false;
                return this.$message.info('未查询到报名学时')
              }
          }
        this.ModifyFlag = true;
      })
    },

    returnSuggestion(row) {
      this.rowData = row;
      this.modalSuggestion = true;
    },

    // 分页器
    onChange(value) {
      this.curPage = value;
      this.getData();
    },
    // pageChange(){

    // },
    // 修改学时确认
    notarize() {
      this.$Modal.confirm({
        title: "是否确认修改学时",
        onOk: () => {
          let obj = JSON.parse(JSON.stringify(this.increase))
          delete obj.money;
          obj.payChannel = 5;
          obj.selectCredit = Number(obj.selectCredit)
          editCreditOrder(obj).then((r) => {
            if (r.data.code === 200) {
              this.ModifyFlag = false;
              genQRCode(r.data.data.orderNo).then((r) => {
                console.log(r, "建行", r.data.data);
                if (r.data.code == 200) {
                  this.src = r.data.data.url.qr;
                  this.modal1 = true;
                  // this.time = setInterval(() => {
                  //   this.payCallBack(row);
                  // },5000);
                }
              });
            } else {
              this.$Message["info"]({
                background: true,
                content: res.data.msg,
                duration: 3,
              });
            }
            this.loading = false;
          });
        },
      });
    },
    // 修改学时取消
    abolish() {
      this.ModifyFlag = false;
    },
    // 修改学时
    modify(row, i) {
      this.ModifyFlag = true;
    },
    confirm() {
      this.modal1 = false;
    },
    selectionChange(e) {
      this.selectList = e;
    },
    cancel() {
      this.modal = false;
      this.formInline = {};
    },
    submit() {
      let formDate = {};
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          if (this.num == 1) {
            formDate = {
              bankAccount: this.formInline.bankAccount,
              bankBranchName: this.formInline.bankBranchName,
              orderNo: this.baseData.orderNo,
              refundReson: this.formInline.refundReson,
              traceNumber: this.formInline.traceNumber,
            };
          } else {
            formDate = {
              bankAccount: this.formInline.bankAccount,
              bankBranchName: this.formInline.bankBranchName,
              orderNo: this.baseData.orderNo,
              refundReson: this.formInline.refundReson,
              userList: this.selectList,
            };
          }
          refundApply(formDate).then((res) => {
            if (res.data.code == 200) {
              this.$Message.success(res.data.msg);
              this.modal = false;
              this.getData();
            } else {
              this.$Message.error(res.data.msg);
            }
          });
        } else {
          this.$Message.info("请完善信息");
        }
      });
    },
    delOrder(row, i) {
      cancelOrder(row.orderNo).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success(res.data.msg);
        } else {
          this.$Message.error(res.data.msg);
        }
        this.getData();
      });
    },
    returnMoney(row, index) {
      console.log(row);
      this.baseData = row;

      if (this.num == 2) {
        selectRefundPeople(this.baseData.orderNo).then((res) => {
          this.list = res.data.data;
        });
      }
      this.modal = true;
    },
    express(row) {
      console.log(row);
      queryExpressNumber(row.orderNo).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$router.push({
            name: "Courier",
            query: {
              data: res.data.data,
            },
          });
        }
      });
    },
    xiangqing(row, index) {
      console.log(row, index);
      this.$router.push({
        name: "dingdanxiangqing",
        query: {
          data: encodeURIComponent(JSON.stringify(row)),
        },
      });
    },
    jiaofei(row, index) {
      console.log(row);
      if (row.status == 1) {
        genQRCode(row.orderNo).then((r) => {
          console.log(r, "建行", r.data.data);
          if (r.data.code == 200) {
            this.src = r.data.data.url.qr;
            this.modal1 = true;
            // this.time = setInterval(() => {
            //   this.payCallBack(row);
            // },5000);
          }
        });
      } else if (row.status == 2) {
        this.$message.warning("已退订,请重新生成订单!");
      } else if (row.status == 3) {
        this.$message.warning("超过支付时间,订单已经取消,请重新生成订单!");
      } else if (row.status == 4) {
        this.$message.warning("订单正在审核退款!");
      } else if (row.status == 5) {
        this.$message.warning("订单已支付成功,无需重复缴费!");
      }
    },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    },
    getData(type) {
      if (type == 2) {
        this.curPage = 1;
      }
      if (this.yearNum == "全部") {
        this.type = "";
      } else if (this.yearNum == "待支付") {
        this.type = 1;
      } else if (this.yearNum == "已退订") {
        this.type = 2;
      } else if (this.yearNum == "订单关闭") {
        this.type = 3;
      } else if (this.yearNum == "待审核退款") {
        this.type = 4;
      } else if (this.yearNum == "支付成功") {
        this.type = 5;
      }
      queryUserOrder({
        curPage: this.curPage,
        maxPage: this.maxPage,
        status: this.type,
      }).then((res) => {
        console.log(res, "我的订单");
        this.data1 = res.data.data.data;
        this.data1.forEach(f => {
            let timearr = f.orderTime.replace(" ", ":").replace(/\:/g, "-").split("-");
            let timestr = ""+timearr[0];
            f.trainTimes = timestr;
            
            let time = Date.parse(f.orderTime);
            let now = new Date().getTime();
            let runDate = ((now - time) / (1000 * 3600 * 24)).toFixed(0);
            f.runDate = runDate
            console.error(runDate,'runDate');
        })
        this.total = res.data.data.total;
        console.log(this.total < 10);
        // if(res.data.data.total < 10 ){
        // 	this.total = 1;
        // }
        // else{
        // 	this.total = Math.ceil(res.data.data.total / this.maxPage);
        // }
      });
    },
    payCallBack(row) {
      payCallBack(row.orderNo).then((res) => {
        console.log(res, "建行回调");
        if (res.data.code == 200) {
          clearInterval(this.time);
          this.time = null;
          this.modal1 = false;
          this.getData();
        }
      });
    },
    yearChange(v) {
      this.yearNum = v;
      this.getData(2);
    },
    // 处理身份证
    codeSplice(code) {
      return code.substr(0, 6) + "************";
    },
    arrSlice(arr) {
      arr.slice(5);
    },
    sizeChange(size) {},
    pageChange(page) {},
  },
};
</script>

<style scoped>
@import url("../../../assets/css/liucss/order.css");

.details {
  margin-left: 10px;
  display: inline-block;
}

.paymentSpan {
  text-align: center;
  font-size: 18px;
  display: block;
  color: #4771ea;
}
</style>
